/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Sidebar } from "primereact/sidebar";
import React, { useEffect, useState } from "react";
import PerfilAPI from "../../api/catalogs/PerfilAPI";
import PerfilDetalle from "./PerfilDetalle";
import PerfilFiltro from "./PerfilFiltro";
import { Constantes } from "../../shared/Constantes";

const defaultFilter = {};

const Perfil = ({ puedeEditar }) => {
    const [filtro, setFiltro] = useState(defaultFilter);
    const [datos, setDatos] = useState([]);
    const api = PerfilAPI();
    const [visible, setVisible] = useState(false);
    const [id, setId] = useState(0);

    const buscar = async () => {
        const result = await api.getAll(filtro);
        setDatos(result)
    };

    useEffect(() => {
        buscar().then();
    }, []);

    const templateActivo = (item) => (
        <>
            {item?.activo ? 'Activo' : 'Inactivo'}
        </>
    );

    const headerButton = () => (
        <>
            {puedeEditar &&
                <Button type="button" icon="pi pi-plus" onClick={() => verDetalle(0)} text />
            }
        </>
    );

    const editButton = (item) => (
        <Button type="button" icon={`${puedeEditar ? 'pi pi-pencil' : 'pi pi-eye'}`} onClick={() => verDetalle(item.id)} text />
    );

    const verDetalle = (id) => {
        setId(id);
        setVisible(true);
    };

    const onSave = async () => {
        setVisible(false);
        await buscar();
    };

    return (
        <div className="container-fluid ">
            <PerfilFiltro filtro={filtro} onChange={setFiltro} onSearch={buscar} />
            <DataTable value={datos} paginator={true}
                rows={10} emptyMessage={Constantes.emptyMessage}
                paginatorTemplate={Constantes.paginatorTemplate}
                rowsPerPageOptions={Constantes.rowsPerPageOptions}>
                <Column body={editButton} header={headerButton} />
                <Column field="nombre" header="Perfil" headerClassName="center" />
                <Column field="activo" header="Estatus" headerClassName="center" body={templateActivo} />
            </DataTable>
            <Sidebar visible={visible} position="right" className="p-sidebar-lg" onHide={() => setVisible(false)} dismissable={false}>
                <PerfilDetalle id={id} onClose={() => setVisible(false)} puedeEditar={puedeEditar} onSave={onSave} />
            </Sidebar>
        </div >
    );
};

export default Perfil;